import { useEffect, useState } from "react";
import { ContainerNew } from "../../../dashboard/pages/home-new/styled";
import { GET } from "../../../../services/api";

const HomeNew = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [signatureLink, setSignatureLink] = useState("");

  useEffect(() => {
    let isMounted = true;

    const loadSignatureLink = async () => {
      setIsLoading(true);
      setIsError(false);

      const result = await GET({ endpoint: "/payments/signature-link" });
      if (!isMounted) return;

      if (result === false || !result?.data?.data?.link) {
        setIsError(true);
        setIsLoading(false);
        return;
      }

      setSignatureLink(result.data.data.link);
      setIsLoading(false);
    };

    loadSignatureLink();
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <>
      <ContainerNew>
        {isLoading && (
          <div className="p-6 text-sm text-gray-600">Carregando página de assinatura...</div>
        )}
        {isError && (
          <div className="p-6 text-sm text-red-600">Não foi possível carregar a página de assinatura.</div>
        )}
        {!isLoading && signatureLink && (
          <iframe
            className="pb-3"
            src={signatureLink}
            style={{ border: 0, width: "100%", height: "100vh" }}
            title="Página de assinatura"
          />
        )}
      </ContainerNew>
    </>
  );
};

export default HomeNew;
